export default function ServicesAlliances() {
  return null;
}
